import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {CallLogFilter, CallLogSummary, CallLogSummaryByDate, ReportService} from '../../report.service';
import {CallLog, CallLogUtils} from '../../call-log.service';
import {UserService} from '../../user.service';
import {SelectComponent} from 'ng2-select';
import {ChartData, Select2Data} from '../../rest-service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {isNullOrUndefined} from 'util';
import {Observable} from 'rxjs/Observable';
import {saveAs} from 'file-saver';
import * as html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';

@Component({
  selector: 'app-detailed-calls',
  templateUrl: './detailed-calls.component.html',
  styleUrls: ['./detailed-calls.component.css']
})
export class DetailedCallsComponent implements OnInit, AfterViewInit {

  @ViewChild('select_limit') selectLimit: SelectComponent;
  limitSelectData: Select2Data[] = [{id: '100', text: '100 registros'}, {id: '500', text: '500 registros'},
    {id: '1000', text: '1000 registros'}, {id: '5000', text: '5000 registros'}, {id: '10000', text: '10000 registros'}];

  @ViewChild('select_report_type') selectReportType: SelectComponent;
  reportTypeSelectData: Select2Data[] = [{id: 'detailed', text: 'Detalhado'}, {id: 'summary', text: 'Sumário'},
    {id: 'graphics', text: 'Gráfico'}];

  @ViewChild('graph_div') graphDiv: ElementRef;

  @ViewChild('cost_by_date_graph') costByDateGraph;

  colorScheme = {
    domain: [
      '#ff3300',
      '#00ff00',
      '#ffff00',
      '#0000ff',
      '#ff9900',
      '#00ccff',
      '#cc0099',
      '#996633',
      '#9900ff',
      '#009900',
      '#666699'
    ]
  };

  detailedResult: CallLog[] = [];
  summaryResult: CallLogSummary[] = [];

  graphSummaryResult$ = new BehaviorSubject<CallLogSummary[]>([]);
  graphSummaryByDateResult$ = new BehaviorSubject<CallLogSummaryByDate[]>([]);
  topExtensionsByCost: ChartData[] = [];
  topCostCentersByCost: ChartData[] = [];
  topCallTypesByCost: ChartData[] = [];
  topCallTypesSimplifiedByCost: ChartData[] = [];
  topSimplifiedLocationByCost: ChartData[] = [];

  filter: CallLogFilter = new CallLogFilter([]);
  dataLoading = false;
  reportMessage = undefined;
  error = false;

  costByDateChartData = {
    chartType: 'ColumnChart',
    dataTable: [],
    options: {'title': 'Custo R$', 'width': 1000, 'height': 450, 'isStacked': true},
  };

  costByDateConfig$ = new BehaviorSubject<any>(undefined);

  reportType$ = new BehaviorSubject<string>(this.reportTypeSelectData[0].id);

  limit = 100;

  callLogUtils = CallLogUtils;

  constructor(private rs: ReportService, private us: UserService) {
  }

  ngOnInit() {
    this.graphSummaryResult$.subscribe(result => {
      const viewSize = this.getViewSize(this.graphDiv);
      const legendSize = viewSize * 0.7;
      const numberOfRegisters = Math.floor(legendSize / 90);
      this.costByDateChartData.options.width = viewSize;

      // Top Extensions
      const topExtensions = result
        .filter(summary => summary.getTotalCost('OUT') > 0)
        .map(summary => ({name: summary.phoneNumber.getPrettyLocalFormat(), value: summary.getTotalCost('OUT')}))
        .sort((a, b) => b.value - a.value);
      this.topExtensionsByCost = this.extractTopResultsAndOthers(topExtensions, numberOfRegisters);

      // Top Cost Centers
      const costByCostCenter = new Map<string, number>();
      result.forEach((value) => {
        let actualCostCenterValue = costByCostCenter.get(value.costCenterName);
        if (isNullOrUndefined(actualCostCenterValue)) {
          actualCostCenterValue = 0;
        }
        actualCostCenterValue += value.getTotalCost('OUT');
        costByCostCenter.set(value.costCenterName, actualCostCenterValue);
      });
      const topCostCenters: ChartData[] = [];
      costByCostCenter.forEach((value, key) => topCostCenters.push({name: key, value: value}));
      topCostCenters.sort((a, b) => b.value - a.value);
      this.topCostCentersByCost = this.extractTopResultsAndOthers(topCostCenters, numberOfRegisters);

      // Top CallTypes
      const costByCallType = new Map<string, number>();
      result.forEach((summary) => {
        let actualCallTypeCost = 0;
        const outCalls = summary.callsCostSumByType.get('OUT');
        if (outCalls) {
          outCalls.forEach((value, key) => {
            actualCallTypeCost = costByCallType.get(key);
            if (isNullOrUndefined(actualCallTypeCost)) {
              actualCallTypeCost = 0;
            }
            actualCallTypeCost += value;
            costByCallType.set(key, actualCallTypeCost);
          });
        }
      });
      const topCallTypes: ChartData[] = [];
      costByCallType.forEach((value, key) => topCallTypes.push({name: key, value: value}));
      topCallTypes.sort((a, b) => b.value - a.value);
      this.topCallTypesByCost = this.extractTopResultsAndOthers(topCallTypes, numberOfRegisters)
        .filter(value => value.value !== 0);

      // Top Call Types simplified
      this.topCallTypesSimplifiedByCost = [];
      const groupedCallTypes = new Map<string, number>();
      costByCallType.forEach((value, key) => {
        if (key.startsWith('VC')) {
          this.addInto(groupedCallTypes, 'Móvel', value);
        } else {
          this.addInto(groupedCallTypes, 'Fixo', value);
        }
      });
      groupedCallTypes.forEach((value, key) => {
        this.topCallTypesSimplifiedByCost.push({name: key, value: value});
      });
      this.topCallTypesSimplifiedByCost.sort((a, b) => b.value - a.value);

      // Top Call by Location simplified
      this.topSimplifiedLocationByCost = [];
      const groupedLocations = new Map<string, number>();
      costByCallType.forEach((value, key) => {
        if (key === 'VC1' || key === 'LOCAL') {
          this.addInto(groupedLocations, 'Mesmo DDD', value);
        } else {
          this.addInto(groupedLocations, 'Outro DDD', value);
        }
      });
      groupedLocations.forEach((value, key) => {
        this.topSimplifiedLocationByCost.push({name: key, value: value});
      });
      this.topSimplifiedLocationByCost.sort((a, b) => b.value - a.value);
    });
    this.graphSummaryByDateResult$.subscribe(result => {
      this.costByDateConfig$.next(undefined);
      if (result.length > 0) {
        if (!this.costByDateGraph.wrapper) {
          this.costByDateChartData.dataTable = this.generateCostByDateChartData(result);
        } else {
          this.costByDateGraph.wrapper.setDataTable(this.generateCostByDateChartData(result));
          this.costByDateGraph.redraw();
        }
        this.costByDateConfig$.next(this.costByDateChartData);
      } else {
        this.costByDateConfig$.next(undefined);
      }
    });
  }

  ngAfterViewInit() {
  }

  setFilter(filter: CallLogFilter) {
    this.filter = filter;
  }

  previewReport() {
    this.dataLoading = true;
    this.error = false;
    this.reportMessage = '';
    const start = new Date();
    const summaryCalls$ = this.rs.getSummaryCalls(this.us.currentUser.getValue().customerDatabaseId, this.filter);
    const summaryCallsByDate$ = this.rs.getSummaryCallsByDate(this.us.currentUser.getValue().customerDatabaseId, this.filter);
    if (this.reportType$.getValue() === 'detailed') {
      this.rs.getDetailedCalls(this.us.currentUser.getValue().customerDatabaseId, this.filter, this.limit)
        .subscribe((result) => {
          this.detailedResult = result;
        }, (err) => {
          this.processError(err);
        }, () => {
          this.finishProcessing(start);
        });
    } else if (this.reportType$.getValue() === 'summary') {
      summaryCalls$.subscribe((result) => {
        this.summaryResult = result;
      }, (err) => {
        this.processError(err);
      }, () => {
        this.finishProcessing(start);
      });
    } else if (this.reportType$.getValue() === 'graphics') {
      Observable.forkJoin(summaryCalls$, summaryCallsByDate$)
        .subscribe(([summary, summaryByDate]) => {
          console.log(`Received summary: ${JSON.stringify(summary)}`);
          console.log(`Received summary by date: ${JSON.stringify(summaryByDate)}`);
          this.graphSummaryResult$.next(summary);
          this.graphSummaryByDateResult$.next(summaryByDate);
        }, (err) => {
          this.processError(err);
        }, () => {
          this.finishProcessing(start);
        });
    }
  }

  downloadExcel() {
    this.dataLoading = true;
    if (this.reportType$.getValue() === 'detailed') {
      this.rs.getDetailedXlsCalls(this.us.currentUser.getValue().customerDatabaseId, this.filter)
        .subscribe(blob => {
          saveAs(blob, 'detailed.xlsx');
        }, (error) => {
          console.error(`Error generating the report: ${JSON.stringify(error)}`)
        }, () => {
          this.dataLoading = false;
        })
    } else if (this.reportType$.getValue() === 'summary') {
      this.rs.getSummaryXlsCalls(this.us.currentUser.getValue().customerDatabaseId, this.filter)
        .subscribe(blob => {
          saveAs(blob, 'summary.xlsx');
        }, (error) => {
          console.error(`Error generating the report: ${JSON.stringify(error)}`)
        }, () => {
          this.dataLoading = false;
        })
    }
  }

  downloadPDF() {
    this.dataLoading = true;
    if (this.reportType$.getValue() === 'detailed') {
      this.rs.getDetailedPdfCalls(this.us.currentUser.getValue().customerDatabaseId, this.filter)
        .subscribe(blob => {
          saveAs(blob, 'detailed.pdf');
        }, (error) => {
          console.error(`Error generating the report: ${JSON.stringify(error)}`)
        }, () => {
          this.dataLoading = false;
        })
    } else if (this.reportType$.getValue() === 'summary') {
      this.rs.getSummaryPdfCalls(this.us.currentUser.getValue().customerDatabaseId, this.filter)
        .subscribe(blob => {
          saveAs(blob, 'summary.pdf');
        }, (error) => {
          console.error(`Error generating the report: ${JSON.stringify(error)}`)
        }, () => {
          this.dataLoading = false;
        })
    } else {
      html2canvas(document.getElementById('report-div')).then(function (canvas) {
        const img = canvas.toDataURL('image/jpeg');
        const doc = new jsPDF('p', 'mm', 'a4', 1);
        console.log(`canvas: ${JSON.stringify(canvas)}`);
        doc.addImage(img, 'JPEG', 0, 0, 200, 300);
        doc.save('graphs.pdf');
      });
    }
  }

  processError(err: any) {
    console.error(err);
    this.error = true;
    this.reportMessage = 'Erro ao gerar o relatório...';
    this.finishReport();
  }

  finishProcessing(start: Date) {
    this.finishReport();
    const end = new Date();
    if (this.reportType$.getValue() === 'detailed') {
      this.reportMessage = `Encontrados ${this.detailedResult.length} registros(${(end.getTime() - start.getTime()) / 1000} segundos)`;
    } else if (this.reportType$.getValue() === 'summary') {
      this.reportMessage = `Encontrados ${this.summaryResult.length} registros(${(end.getTime() - start.getTime()) / 1000} segundos)`;
    } else {
      this.reportMessage = `Relatório finalizado em (${(end.getTime() - start.getTime()) / 1000} segundos)`;
    }
  }

  finishReport() {
    this.dataLoading = false;
  }

  setLimit(event: Select2Data) {
    this.limit = parseInt(event.id, 10);
  }

  setType(event: Select2Data) {
    this.reportType$.next(event.id);
  }

  getCellClass({row, column, value}): any {
    return {'datatable-row-left': true}
  }

  graphSelect(event: any) {
    console.log(`Received: ${JSON.stringify(event)}`);
  }

  getViewSize(element: ElementRef): number {
    if (element) {
      return this.graphDiv.nativeElement.offsetWidth;
    }
    return 0;
  }

  extractTopResultsAndOthers(values: ChartData[], maxValues: number): Array<ChartData> {
    if (maxValues >= values.length) {
      return values;
    }
    const result: ChartData[] = [];
    const others: ChartData = {name: 'Outros', value: 0.0};
    values.forEach((value, index) => {
      if (index < (maxValues - 1)) {
        result.push(value);
      } else {
        others.value += value.value;
      }
    });
    result.push(others);
    return result;
  }

  addInto(map: Map<string, number>, key: string, value: number) {
    let actualValue = map.get(key);
    if (!actualValue) {
      actualValue = 0;
    }
    actualValue += value;
    map.set(key, actualValue);
  }

  generateCostByDateChartData(data: CallLogSummaryByDate[]): Array<Array<any>> {
    const costByType = new Map<string, number>();
    data.forEach(value => {
      const outCost = value.callsCostSumByType.get('OUT');
      if (outCost) {
        outCost.forEach((cost, type) => {
          const actualCost = costByType.get(type);
          if (actualCost) {
            costByType.set(type, (actualCost + cost));
          } else {
            costByType.set(type, cost);
          }
        });
      }
    });
    const values = Array.from(costByType.entries());
    const columns = values
      .sort((a, b) => a[1] - b[1])
      .filter(value => value[1] > 0)
      .map(value => value[0]);
    columns.unshift('Data');
    const result: any[][] = [];
    data.forEach((summary) => {
      const line: any[] = [];
      // const date = new Date(summary.date);
      // line.push(`${date.getDate()}/${date.getMonth() + 1}`);
      line.push(new Date(summary.date));
      columns.forEach((type, index) => {
        if (index > 0) {
          const outCost = summary.callsCostSumByType.get('OUT');
          let typeValue = undefined;
          if (outCost) {
            typeValue = outCost.get(type);
          }
          if (typeValue) {

            line.push(typeValue);
          } else {
            line.push(0);
          }
        }
      });
      result.unshift(line);
    });
    result.unshift(columns);
    return result;
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/billing/detailed-calls/detailed-calls.component.ts